import { formattedValues } from '@/model/contact-info.mjs';
import { LicenseByZipParamsInterface } from '@/model/explore';
import { Firearms } from '@/model/firearm-type.mjs';
import { callToEZCheckValidator } from '@/queue/ducks/slice';
import { Dispatch } from '@reduxjs/toolkit';
import { ContactDetail, CustomAddress } from '../types';

/**
 * Format a number as a US telephone number
 * @param phoneNumberString
 */
export function formatPhoneNumber(phoneNumberString: string) {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3];
  }
  return null;
}

/**
 * If the value is empty, use the fallback value
 * @param value
 * @param fallback
 */
export function withFallback(
  value: Array<string> | string | number | null | undefined,
  fallback = '-'
) {
  if (value === undefined || value === null || value === '' || value === 0) {
    return fallback;
  }
  return value;
}

export function withDollarSign(price?: number) {
  if (price) {
    return `$${price}`;
  }
  return '-';
}

export function ezCheck(disptach: Dispatch, data: { license_key: string }) {
  disptach(callToEZCheckValidator({ license_key: data?.license_key }));
  window.open(
    `https://fflezcheck.atf.gov/FFLEzCheck/fflSearch?licsRegn=${
      data.license_key[0]
    }&licsDis=${data.license_key.slice(1, 3)}&licsSeq=${data.license_key.slice(
      -5
    )}`
  );
}

export function formatLicenseKey(id: string) {
  
  const first1 = id?.substring(0, 1) || '';
  let second2 = id?.substring(2, 4) || '';
  const last5 = id?.substring(id.length - 5) || '';
  if (id && id.length == 8) second2 = id?.substring(1, 3) || '';
  return { first1, second2, last5 };
}

export function getEightDigitLicenseKey(id: string) {
  const { first1, second2, last5 } = formatLicenseKey(id);
  return `${first1}${second2}${last5}`
}

export const disabledStyle = {
  opacity: 0.5,
  pointerEvents: 'none'
};

export function getPrimaryValue(data: formattedValues[]){
  const phoneNumber = getPrimary(data)
  return phoneNumber ? formatPhoneNumber(phoneNumber) :  null
}

export function getPrimary(data: formattedValues[]){
  return data?.find(item => item.isPrimary)?.value || null
}

export function getPrimaryContact(data: formattedValues[]) {
  return data?.find(item => item.isPrimary)?.value ? data?.find(item => item.isPrimary)?.value : data[0] ? data[0].value : null
  
}

export function transformContactDetails(contactDetails: Array<ContactDetail> | null) {
  if(!contactDetails || (contactDetails && contactDetails.length <= 0)) return [];
  const primaryContactDetails = contactDetails.filter((contact) => contact.isPrimary);
  const otherContactDetails = contactDetails.filter((contact) => !contact.isPrimary);
  return [...primaryContactDetails, ...otherContactDetails];
}

export const getFormattedProduct = (product: any) => {
  if (product) {
    const pistolObject = Firearms.find((item) => item.value === product);
    return pistolObject && pistolObject.type ? pistolObject.type : '-'
  }
  return '-'
} 

export function getPrimaryPhone(data: formattedValues[]){
  return data?.find(item => item.isPrimary) || null
}

export const agGridIconsConfig = {
  menu: "<img src='/images/ui/menu-dark.svg' />",
  columns: "<img src='/images/ui/columns.svg' />",
}
